import { ListingActionTypes, SearchActionTypes } from '@state/features/common.types';
import analytics from '@utils/analytics';
import { getDefferedTransition, tranitionDomReady } from '@utils/landingAnimations';
import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import { debounce } from '@utils/functions';
import { motion } from 'framer-motion';
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import NewBreadcrumb from './NewBreadcrumb';
import PlpIntroBreadcrumb from './PlpIntroBreadcrumb';
import PlpIntroTags from './PlpIntroTags';
import SortBy from './SortBy';
import Lazyimg from '@components/utils/Lazyimg';
import ProductFilterCheckbox from './ProductFilterCheckbox';
const variants = {
    active: {
        opacity: 1,
    },
    inactive: {
        opacity: 0,
    },
};
const ProductFilters = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { landingAnimation, productSort, refinements, category, selectedFilters, selectedSort, sizeGroups, inSearch, inputSearch, count, filteredCategory } = useSelector((state) => state.search);
    const [refineExpanded, setRefineExpanded] = useState(false);
    const [selectedRefinement, setSelectedRefinement] = useState('');
    const [sortingExpanded, setSortingExpanded] = useState(false);
    const [startAnimation, setStartAnimation] = useState(false);
    const [categoryRefinement, setCategoryRefinement] = useState();
    const [refineContainerPLPHeight, setRefineContainerPLPHeight] = useState();
    const [lastValidRefinements, setLastValidRefinements] = useState();
    const isFromAPP = window.appmode;
    const getRefinementType = () => {
        return inSearch ? SearchActionTypes.UPDATE_SEARCH_REFINEMENT : ListingActionTypes.UPDATE_LISTING_REFINEMENT;
    };
    useEffect(() => {
        if (props.setFilterExpandedStatus) {
            props.setFilterExpandedStatus(refineExpanded);
        }
    }, [refineExpanded]);
    useEffect(() => {
        if (landingAnimation) {
            setTimeout(() => {
                setStartAnimation(true);
                // aspetto 550ms che è il tempo dell'animazione al dom loaded
            }, 750);
        }
    }, [landingAnimation]);
    const headerRef = useRef(document.querySelector('header')).current;
    const bodyRef = useRef(document.querySelector('body')).current;
    const refineRef = useRef(null);
    const refineContainerPLP = useRef(null);
    const refinePLPHeading = useRef(null);
    const wrapperRefineButton = useRef(null);
    const currentBreakpoint = useBreakpoint();
    const isDesktop = useMemo(() => {
        return currentBreakpoint >= window.mqObj.md;
    }, [currentBreakpoint]);
    const getTopVal = () => {
        const elPaddingTop = parseInt(window.getComputedStyle(refineContainerPLP.current).paddingTop);
        const elPaddingBot = parseInt(window.getComputedStyle(refineContainerPLP.current).paddingBottom);
        const isDesktop = currentBreakpoint >= window.mqObj.md;
        let topVal = headerRef ? headerRef.offsetHeight : 0;
        if (isDesktop) {
            topVal -= refineContainerPLP.current.offsetHeight;
        }
        else if (props.plpintro) {
            topVal -= refinePLPHeading.current.offsetHeight + elPaddingTop - elPaddingBot;
        }
        else if (isFromAPP) {
            topVal = 0;
        }
        else if (wrapperRefineButton.current) {
            topVal -= refineContainerPLP.current.offsetHeight - wrapperRefineButton.current.offsetHeight - elPaddingBot * 2;
        }
        return topVal;
    };
    // willStick used in listing
    useLayoutEffect(() => {
        if (props.willStick) {
            const refineResizeObserver = new ResizeObserver(debounce(() => {
                setRefineContainerPLPHeight(getTopVal());
            }, 300));
            if (refineResizeObserver) {
                refineResizeObserver.observe(refineContainerPLP.current);
                headerRef && refineResizeObserver.observe(headerRef);
            }
            return () => {
                if (refineResizeObserver) {
                    refineResizeObserver.unobserve(refineContainerPLP.current);
                    headerRef && refineResizeObserver.unobserve(headerRef);
                }
            };
        }
    }, [props.willStick, refineContainerPLP, headerRef, currentBreakpoint]);
    const isMountRef = useRef(true);
    useEffect(() => {
        if (!isMountRef.current) {
            dispatch({
                type: inSearch ? SearchActionTypes.FETCH_SEARCH : ListingActionTypes.FETCH_LISTING,
                payload: {
                    resultsType: inSearch ? 'REFINE' : 'INIT',
                },
            });
            // removed for OE-27869 request
            // document.documentElement.scrollTop = 0;
            setTimeout(() => {
                document.documentElement.style.removeProperty('scroll-behavior');
            }, 1000);
        }
        isMountRef.current = false;
    }, [selectedFilters, filteredCategory, selectedSort]);
    // LISTING ONLY effect che ri-esegue la ricerca al cambio filtri/sort
    // useEffect(() => {
    //   if (!inSearch && !firstLoad) {
    //     dispatch({
    //       type: ListingActionTypes.FETCH_LISTING,
    //       payload: {
    //         resultsType: 'INIT',
    //       },
    //     });
    //     document.documentElement.scrollTop = 0;
    //     setTimeout(() => {
    //       document.documentElement.style.removeProperty('scroll-behavior');
    //     }, 1000);
    //   }
    // }, [selectedFilters, selectedSort]);
    const refineIsVisibile = () => {
        return refineExpanded || isDesktop;
    };
    const refineWrapper = useRef();
    const refineContainer = useRef();
    const currentSortOption = useMemo(() => {
        return productSort === null || productSort === void 0 ? void 0 : productSort.options.find((option) => {
            let sortingRuleId_temp = option.sortingRuleId;
            let selectedSort_temp = selectedSort;
            if (sortingRuleId_temp == selectedSort_temp) {
                return true;
            }
            else {
                return false;
            }
        });
    }, [selectedSort, productSort]);
    const openRefineModal = () => {
        var _a;
        //Refine button is now only present in mobile
        // per evitare di rompere la modale dei filtri
        if (headerRef && !!headerRef.style.getPropertyValue('transform')) {
            bodyRef.style.overflowY = 'hidden';
            headerRef.style.removeProperty('transform');
            (_a = refineRef.current) === null || _a === void 0 ? void 0 : _a.style.removeProperty('transform');
            setTimeout(() => {
                setRefineExpanded(!refineExpanded);
                setSelectedRefinement('');
                setSortingExpanded(false);
                bodyRef.style.overflowY = 'auto';
            }, 500);
        }
        else {
            setRefineExpanded(!refineExpanded);
            setSelectedRefinement('');
            setSortingExpanded(false);
        }
        window.sprChat && window.sprChat('disable');
    };
    const closeRefine = () => {
        if (isDesktop) {
            refineContainer.current.style.removeProperty('height');
        }
        else {
            window.sprChat && window.sprChat('enable');
        }
        setRefineExpanded(false);
        setSelectedRefinement('');
    };
    const toggleSelectedRefinement = (refinementID, forceHide) => {
        if (isDesktop) {
            if (forceHide || refinementID === selectedRefinement) {
                closeRefine();
            }
            else {
                //Open panel
                const currentFilter = document.querySelector(`#${refinementID}`).nextElementSibling;
                refineContainer.current.style.height = `${currentFilter.offsetHeight + refineWrapper.current.offsetHeight}px`;
                setSelectedRefinement(refinementID);
            }
            setSortingExpanded(false);
        }
        else {
            setSelectedRefinement(refinementID === selectedRefinement ? '' : refinementID);
            setSortingExpanded(false);
            // scroll to start accordion
            const currentFilter = document.querySelector(`#${refinementID}`);
            if (currentFilter) {
                setTimeout(() => {
                    let currentFilterParent = currentFilter.closest('li');
                    if (currentFilterParent) {
                        let prevCurrentFilterParent = currentFilter.previousElementSibling;
                        if (prevCurrentFilterParent) {
                            let topPositionPrevCurrentFilterParent = prevCurrentFilterParent.getBoundingClientRect().top;
                            let scrollTopRefineContainer = refineContainer.current.scrollTop;
                            refineContainer.current.scrollTo({ top: topPositionPrevCurrentFilterParent + scrollTopRefineContainer });
                        }
                        else {
                            currentFilterParent.scrollIntoView();
                        }
                    }
                }, 50);
            }
        }
    };
    const openSort = () => {
        if (isDesktop) {
            document.querySelector('.sort__list--wrapper').style.height = document.querySelector('.sort__list').offsetHeight.toString() + 'px';
        }
        else {
            // handle resize
            document.querySelector('.sort__list--wrapper').style.removeProperty('height');
        }
        setSortingExpanded(true);
    };
    const closeSort = () => {
        if (isDesktop) {
            document.querySelector('.sort__list--wrapper').style.height = '0';
        }
        else {
            // handle resize
            document.querySelector('.sort__list--wrapper').style.removeProperty('height');
        }
        const sortButton = document.querySelector('#sortButton');
        sortButton === null || sortButton === void 0 ? void 0 : sortButton.classList.add('animate-arrow');
        setSortingExpanded(false);
        setTimeout(() => {
            sortButton === null || sortButton === void 0 ? void 0 : sortButton.classList.remove('animate-arrow');
        }, 200);
    };
    const toggleSort = (forceHide) => {
        if (isDesktop) {
            if (!sortingExpanded && !forceHide) {
                openSort();
            }
            else {
                closeSort();
            }
        }
        else {
            //MOBILE
            setSortingExpanded(!sortingExpanded);
        }
        setSelectedRefinement('');
    };
    const allFiltersCount = useMemo(() => {
        return selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.reduce((count, filter) => {
            var _a;
            return count + (((_a = filter === null || filter === void 0 ? void 0 : filter.values) === null || _a === void 0 ? void 0 : _a.length) || 0);
        }, 0);
    }, [selectedFilters]);
    // START - Used to retrieve initial refinement tabs (ie. genders filters ) after choosing a refine and navigate into and out PDP
    useEffect(() => {
        const lastSearch = sessionStorage.getItem('lastSearch');
        const lastSearchObj = lastSearch && JSON.parse(lastSearch);
        if (lastSearchObj && lastSearchObj.inputSearch && lastSearchObj.categoryRefinement) {
            const params = new URLSearchParams(window.location.search);
            const queryParam = params.get('query');
            if (!queryParam) {
                return;
            }
            else if (lastSearchObj.inputSearch === queryParam) {
                setCategoryRefinement(lastSearchObj.categoryRefinement);
            }
            else {
                sessionStorage.setItem('lastSearch', '');
            }
        }
    }, []);
    useEffect(() => {
        var _a;
        if (inputSearch && ((_a = categoryRefinement === null || categoryRefinement === void 0 ? void 0 : categoryRefinement.values) === null || _a === void 0 ? void 0 : _a.length)) {
            sessionStorage.setItem('lastSearch', JSON.stringify({ inputSearch: inputSearch, categoryRefinement: categoryRefinement }));
        }
    }, [categoryRefinement]);
    // END - Used to retrieve initial refinement tabs (ie. genders filters ) after choosing a refine and navigate into and out PDP
    useEffect(() => {
        let categoryRefinement = refinements === null || refinements === void 0 ? void 0 : refinements.find((refinement) => refinement.isCategoryRefinement);
        if (categoryRefinement && !categoryRefinement.values.find((v) => v.selected)) {
            setCategoryRefinement(categoryRefinement); // don't change if a category has been selected
        }
        if (!props.fromSearch && refinements.length > 0) {
            setLastValidRefinements(refinements);
        }
    }, [refinements]);
    useEffect(() => {
        if (!isDesktop) {
            document.documentElement.style.setProperty('overflow', refineExpanded ? 'hidden' : '');
        }
    }, [refineExpanded]);
    // const filteredCategory: string = useMemo(() => {
    //   return refinements?.find((refinement) => refinement.isCategoryRefinement)?.values?.find((v) => v.selected)?.id;
    // }, [refinements]);
    const getFilter = (filterId) => {
        return selectedFilters.find((filter) => {
            return filter.id === filterId;
        });
    };
    const filterCount = (refinement) => {
        var _a, _b;
        let count = ((_b = (_a = getFilter(refinement.attributeID)) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.length) || 0;
        // Fallback per back da PDP
        if (!count) {
            refinement.values.map((v) => {
                if (v.selected) {
                    count++;
                }
            });
        }
        return !!count && React.createElement("sup", { "aria-label": t('refine.currentlyselectedfilters') + ' ' + count }, count);
    };
    const resetFilters = (filterId) => {
        closeRefine();
        dispatch({
            type: getRefinementType(),
            payload: {
                filterAction: 'RESET',
                filterId,
            },
        });
    };
    const sortItems = (option) => {
        dispatch({
            type: getRefinementType(),
            payload: {
                filterAction: 'SORT',
                selectedSort: option.sortingRuleId,
            },
        });
        //setCurrentSortOption(option);
        if (isDesktop) {
            closeRefine();
        }
    };
    const addFilterValue = (filterId, valueId) => {
        dispatch({
            type: getRefinementType(),
            payload: {
                filterAction: 'ADD',
                filterId,
                valueId,
            },
        });
    };
    const sizeGroupFilter = (refinement, key) => {
        const sizeGroup = sizeGroups[key];
        return sizeGroup.length > 0 ? (React.createElement("div", { className: "filters__menu__group", key: key },
            React.createElement("fieldset", { className: "fieldset--plain" },
                React.createElement("legend", { className: "filters__menu__group-name" }, t(`sizegroup.${key}`)),
                React.createElement("ul", null, sizeGroup.map((item, i) => {
                    return (React.createElement(ProductFilterCheckbox, { key: i + item.displayValue, refinement: refinement, refinementValue: item, index: i, addFilterValue: addFilterValue, fromSearch: props.fromSearch }));
                }))))) : (React.createElement(React.Fragment, null));
    };
    const onComplete = () => {
        if (!inSearch) {
            setTimeout(() => {
                // aspetto 100ms per evitare microlag
                dispatch({ type: ListingActionTypes.TOGGLE_LANDING_ANIMATION, payload: false });
            }, 100);
        }
    };
    const sendFiltersAnalytics = (refinement) => {
        if (refinement.attributeID != selectedRefinement)
            props.fromSearch
                ? analytics.searchRefineFirstLevel(refinement.attributeID ? refinement.attributeID : refinement.displayName)
                : analytics.refineFirstLevel(refinement.attributeID ? refinement.attributeID : refinement.displayName);
    };
    // HOVER EVENTS REMOVAL ON PLP FILTERS [OE-15483]
    const onFiltersHoverHandler = (refinement, forceHide) => {
        if (isDesktop) {
            toggleSelectedRefinement(refinement.attributeID, forceHide);
            // HOVER EVENTS REMOVAL ON PLP FILTERS [OE-15483]
            // sendFiltersAnalytics(refinement);
        }
    };
    const onFiltersClickHandler = (refinement) => {
        toggleSelectedRefinement(refinement.attributeID, false);
        sendFiltersAnalytics(refinement);
    };
    const subCategoryTitle = () => {
        return React.createElement("h1", { className: "plp-heading__subcategory-title" }, (category === null || category === void 0 ? void 0 : category.plpName) || (category === null || category === void 0 ? void 0 : category.name));
    };
    const refineButton = () => {
        return (React.createElement(motion.div, { transition: getDefferedTransition(3), initial: { opacity: 0 }, animate: { opacity: !startAnimation && landingAnimation ? 0 : 1 }, className: "wrapper-refine-button", ref: wrapperRefineButton },
            React.createElement("button", { type: "button", onClick: () => {
                    openRefineModal();
                    if (!refineExpanded) {
                        props.fromSearch ? analytics.searchRefineOpen() : analytics.refineOpen();
                    }
                }, "aria-expanded": refineExpanded, "aria-controls": "refineOptions", className: "refine__toggle" },
                React.createElement("span", null, t('refine.title')),
                allFiltersCount > 0 && React.createElement("sup", { "aria-label": t('refine.currentlyselectedfilters') + ' ' + allFiltersCount }, allFiltersCount))));
    };
    const appHeaderBar = () => {
        return (React.createElement("div", { className: "app-header-bar" },
            React.createElement("button", { className: "button", onClick: () => history.back() },
                React.createElement("i", { className: "icon--arrow-left-black" })),
            subCategoryTitle(),
            refineButton()));
    };
    const hasRefinements = () => {
        var _a;
        return ((_a = categoryRefinement === null || categoryRefinement === void 0 ? void 0 : categoryRefinement.values) === null || _a === void 0 ? void 0 : _a.length) > 1;
    };
    const shownRefinements = useMemo(() => {
        if (props.fromSearch || refinements.length > 0) {
            return refinements;
        }
        else {
            // If in PLP refinements are empty, we show the last ones to let the user deselect something
            // To avoid weird selections, we only allow to (de)select the already selected ones
            const noResultsFilters = lastValidRefinements.map((r) => {
                return Object.assign(Object.assign({}, r), { values: r.values.map((v) => {
                        return Object.assign(Object.assign({}, v), { selectable: v.selected });
                    }) });
            });
            return noResultsFilters;
        }
    }, [refinements]);
    return (React.createElement("div", { ref: refineRef, className: classNames('refine', { expanded: refineExpanded }, { 'from-app': isFromAPP }), style: { top: refineContainerPLPHeight } },
        React.createElement("div", { className: classNames('container results-row', !inSearch && 'in-plp', props.plpintro && 'intro-plp', ((_b = (_a = props.plpintro) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.path) && 'image-bg', hasRefinements() && 'with-refinements'), ref: refineContainerPLP },
            ((_d = (_c = props.plpintro) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.path) && (React.createElement("picture", { className: "intro-plp__image" },
                ((_f = (_e = props.plpintro) === null || _e === void 0 ? void 0 : _e.image_mobile) === null || _f === void 0 ? void 0 : _f.path) && React.createElement("source", { media: "(max-width: 768px)", srcSet: (_g = props.plpintro) === null || _g === void 0 ? void 0 : _g.image_mobile.path }),
                React.createElement(Lazyimg, { src: (_j = (_h = props.plpintro) === null || _h === void 0 ? void 0 : _h.image) === null || _j === void 0 ? void 0 : _j.path, alt: "" }))),
            !inSearch ? (React.createElement(motion.div, { transition: tranitionDomReady, initial: { opacity: 0 }, animate: { opacity: 1 }, className: "plp-heading", ref: refinePLPHeading },
                ((_l = (_k = props.plpintro) === null || _k === void 0 ? void 0 : _k.image) === null || _l === void 0 ? void 0 : _l.path) && props.plpintro.logo && React.createElement(Lazyimg, { className: "plp-heading__collection-logo", src: props.plpintro.logo.path, alt: "logo" }),
                ((_m = props.plpintro) === null || _m === void 0 ? void 0 : _m.regions.breadcrumbs_area.components.length) ? (React.createElement(PlpIntroBreadcrumb, { logo: props.plpintro.logo, logo_link: props.plpintro.logo_link, breadcrumbs: props.plpintro.regions.breadcrumbs_area.components })) : (React.createElement(NewBreadcrumb, null)),
                props.plpintro ? (React.createElement(PlpIntroTags, { tags: props.plpintro.regions.tags_area.components, title: props.plpintro.title || (category === null || category === void 0 ? void 0 : category.plpName) || (category === null || category === void 0 ? void 0 : category.name), description: props.plpintro.description || (category === null || category === void 0 ? void 0 : category.description), readMore: props.plpintro.read_more || (category === null || category === void 0 ? void 0 : category.descriptionReadMore) })) : (React.createElement("div", { className: "plp-heading__title-bar" }, subCategoryTitle())))) : (React.createElement(React.Fragment, null, hasRefinements() && (React.createElement("form", { className: "search-maincategories" },
                React.createElement("fieldset", null,
                    React.createElement("legend", { className: "visually-hidden" }, t('search.category.a11y')),
                    React.createElement("label", { key: 'all', className: classNames({ active: !filteredCategory }) },
                        React.createElement("input", { type: "radio", value: 'all', name: "search-categories", onClick: () => {
                                analytics.filterByGender('all');
                                dispatch({
                                    type: getRefinementType(),
                                    payload: {
                                        filterAction: 'ADD',
                                        id: 'all',
                                    },
                                });
                            } }),
                        React.createElement("span", null,
                            " ",
                            t(`search.category.all`))), (_o = categoryRefinement === null || categoryRefinement === void 0 ? void 0 : categoryRefinement.values) === null || _o === void 0 ? void 0 :
                    _o.filter((v) => v.id != 'genius').map((gender) => (React.createElement("label", { key: gender.id, className: classNames({ active: gender.id == filteredCategory }) },
                        React.createElement("input", { type: "radio", value: gender.id, name: "search-categories", onClick: () => {
                                analytics.filterByGender(gender.id);
                                dispatch({
                                    type: getRefinementType(),
                                    payload: {
                                        filterAction: 'ADD',
                                        id: gender.id,
                                    },
                                });
                            } }),
                        React.createElement("span", null, gender.displayValue))))))))),
            !isDesktop ? (isFromAPP ? appHeaderBar() : refineButton()) : ''),
        !props.fullyEditorialPlp && (React.createElement(motion.div, { transition: getDefferedTransition(3), initial: { opacity: 0 }, animate: { opacity: !startAnimation && landingAnimation ? 0 : 1 }, onAnimationComplete: onComplete, style: { opacity: 0 } },
            React.createElement("div", { ref: refineWrapper, id: "refineOptions", className: classNames('refine__options', refineIsVisibile() && 'is-visible') },
                React.createElement("div", { className: "refine__header" },
                    React.createElement("div", { className: "container" },
                        React.createElement("p", { className: "refine__header__title" },
                            t('refine.title'),
                            allFiltersCount > 0 && React.createElement("sup", { "aria-label": t('refine.currentlyselectedfilters') + ' ' + allFiltersCount }, allFiltersCount)),
                        React.createElement("button", { type: "button", "aria-label": t('button.close'), className: "modal__close", onClick: () => {
                                closeRefine();
                            } }))),
                React.createElement("div", { ref: refineContainer, className: "container refine__container" },
                    React.createElement("ul", { id: "filters1", className: classNames('filters', selectedRefinement != '' && 'expanded'), "aria-label": t('refine.title') }, shownRefinements &&
                        (shownRefinements === null || shownRefinements === void 0 ? void 0 : shownRefinements
                        // ?.filter((refinement) => refinement.values.length > 1 || refinement.values[0].selected)
                        .filter((refinement) => refinement.values.length > 1 && !refinement.isCategoryRefinement).map((refinement, i) => (React.createElement("li", { key: i, onMouseLeave: () => {
                                onFiltersHoverHandler(refinement, true);
                            }, onMouseEnter: () => {
                                onFiltersHoverHandler(refinement, false);
                            } },
                            React.createElement("button", { id: refinement.attributeID, type: "button", onClick: () => {
                                    onFiltersClickHandler(refinement);
                                }, "aria-expanded": refinement.attributeID === selectedRefinement, "aria-controls": 'filters-' + refinement.attributeID, className: classNames('filters__menuitem', selectedRefinement && refinement.attributeID !== selectedRefinement && 'filters__menuitem--off') },
                                refinement.displayName,
                                filterCount(refinement)),
                            React.createElement("div", { id: 'filters-' + refinement.attributeID, className: classNames('filters__menu', 'container', refinement.attributeID === 'size' && sizeGroups && Object.keys(sizeGroups).length > 1
                                    ? 'filters__menu--size-grouped'
                                    : 'filters__menu--' + refinement.attributeID) },
                                refinement.attributeID === 'size' && sizeGroups && Object.keys(sizeGroups).length > 1 ? (React.createElement("div", { className: "filters__menu__wrapper-group" }, Object.keys(sizeGroups).map((groupKey) => {
                                    return sizeGroupFilter(refinement, groupKey);
                                }))) : (React.createElement("ul", null, refinement === null || refinement === void 0 ? void 0 : refinement.values.map((refinementValue, i) => {
                                    return (React.createElement(ProductFilterCheckbox, { key: i + refinementValue.displayValue, refinement: refinement, refinementValue: refinementValue, index: i, addFilterValue: addFilterValue, fromSearch: props.fromSearch }));
                                }))),
                                isDesktop && (React.createElement("button", { type: "button", className: "link", onClick: () => {
                                        resetFilters();
                                        props.fromSearch ? analytics.searchRefineClear() : analytics.refineClear();
                                    } }, t('button.resetall'))))))))),
                    React.createElement(SortBy, { productSort: productSort, sortingExpanded: sortingExpanded, fromSearch: props.fromSearch, currentSortOption: currentSortOption || productSort.options[0], sortItems: sortItems, toggleSort: toggleSort })),
                React.createElement("div", { className: "refine__footer" },
                    React.createElement("div", { className: "container" },
                        React.createElement("button", { type: "button", onClick: () => {
                                resetFilters();
                                props.fromSearch ? analytics.searchRefineClearAll() : analytics.refineClearAll();
                            }, className: "link" }, t('button.resetall')),
                        React.createElement("button", { type: "button", onClick: () => {
                                closeRefine();
                                props.fromSearch ? analytics.searchRefineShow() : analytics.refineShow();
                            }, className: "button button--arrow-right button--tertiary" }, t('refine.showresults')))))))));
};
export default ProductFilters;
